import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import CustomInput from "../../CustomComponent/custom_input";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import { webinarOrderInfo } from "../../SchemaInfo/info";
import { webinarOrderSchema } from "../../Schemas/webinar/webinarorder_create";
import { useNavigate, useParams } from "react-router";
import WebinarCountdown from "./webinarCountDown";
import CustomRadioButton from "../../CustomComponent/custom_radio";
import Footer from "../../Components/Footer/footer";
import { useLocation } from "react-router-dom";
import fridayWebinar from "../../certificates/fridayWebinar.png";
import saturdayWebinar from "../../certificates/saturdayWebinar.png";
import sundayWebinar from "../../certificates/sundayWebinar.png";
import { LazyImageComponent } from "../../CustomComponent/lazy_loading_image";
import { DateTime } from "luxon";
const WebinarNewForm = () => {
  const [loading, setLoading] = useState(false);
  const [personalInfo, setpersonalInfo] = useState(1);
  const [token, setToken] = useState("");
  const navigate = useNavigate();
  const [webinarData, setWebinarData] = useState();
  const [discountedPrice, setDiscountedPrice] = useState(0);
  const { id } = useParams();

  const [expandedIndex, setExpandedIndex] = useState(false);

  const [isChecked, setIsChecked] = useState(true);

  const getDayFromDate = (datestr) => {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    const date = DateTime.fromISO(datestr, { zone: "Asia/Kolkata" });

    if (date.isValid) {
      return days[date.weekday % 7].toUpperCase(); // weekday: 1 (Mon) to 7 (Sun)
    } else {
      return "";
    }
  };

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();
  const discounted = query?.get("discounted");
  const querytoken = query?.get("token");
  const toggleDescription = () => {
    setExpandedIndex(!expandedIndex);
  };
  useEffect(() => {
    const handleGenerateToken = (e) => {
      performRequest("POST", "/payment/generatetoken")
        .then((res) => {
          if (res?.status === 201) {
            setToken(res?.data);
          }
        })
        .catch((err) => {
          console.error("Error", err);
          if (err?.response?.status === 401) {
            Toast("error", err?.response?.data.flag);
          } else if (err?.response?.status === 400) {
            Toast("error", err?.response?.data.flag);
          } else {
            Toast("error", err?.response?.statusText);
          }
        });
    };
    handleGenerateToken();
  }, []);

  const handelSubmit = (values, actions) => {
    
    setLoading(true);
    let data = {
      ...values,
      price: discountedPrice ? parseInt(discountedPrice) : 299,
      token: token,
      date: DateTime.now().setZone("Asia/Kolkata").toISODate(),
      webinarId: id,
      isDiscounted: discountedPrice ? true : false,
      discountedPrice,
      previousWebinarToken: querytoken,
    };

    performRequest("POST", "/payment/create-payment", data)
      .then((res) => {
        if (res?.status === 201) {
          window.location.href = res?.data.longurl;
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Toast("error", err?.response?.data.flag);
        } else if (err?.response?.status === 400) {
          Toast("error", err?.response?.data.flag);
        } else if (err?.response?.status === 409) {
          Toast("error", err?.response?.data.msg);
          navigate("/hydroponic-webinar");
        } else if (err?.response?.status === 400) {
          Toast("error", err?.response?.data.flag);
        } else {
          Toast("error", err?.response?.statusText);
        }
      })
      .finally(() => setLoading(false));
  };

  const handelNext = (values) => {
  
    if (!isChecked) {
      Toast("error", "Please agree to the terms and conditions.");
      return;
    }

    performRequest("POST", `/webinar/createWebinarInterest`, values)
    .then(() => {
      setpersonalInfo((prev) => prev + 1);
    })
    .catch(() => {
      Toast("error", "Failed to save interest");
    });

    // setpersonalInfo(personalInfo + 1);
  };

  useEffect(() => {
    performRequest("GET", `/webinar/getwebinarById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setWebinarData(res.data);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          Toast("error", err?.response?.data?.message);
        } else {
          Toast("error", "N/A");
        }
      });
  }, []);

  useEffect(() => {
    performRequest(
      "GET",
      `/webinar/discounted-webinar/${id}?discounted=true&token=${querytoken}`
    )
      .then((res) => {
        if (res?.status === 200) {
          // setWebinarData(res.data);
          if (res?.data?.isEligibleForDiscount) {
            setDiscountedPrice(res?.data?.discountedPrice);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header">
              <h2 className="page-title mb-1">
                YOU ARE ENROLLING FOR :{" "}
                {webinarData?.webinarName?.toUpperCase()}
              </h2>
              <h4 className="text-muted">
                Fill The Details And Complete Your Enrollment.
              </h4>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-md-6 my-3 text-center">
                  <div className="">
                    {webinarData ? (
                      <div
                        className={`card h-100 d-flex justify-content-between ${
                          webinarData.webinarStatus !== "upcoming"
                            ? "cursor-not-allowed border border-danger"
                            : ""
                        }`}
                        style={{
                          filter:
                            webinarData.webinarStatus !== "upcoming"
                              ? "blur(1px) brightness(0.9)"
                              : "none",
                          pointerEvents:
                            webinarData.webinarStatus !== "upcoming"
                              ? "none"
                              : "auto",
                          transition: "filter 0.3s ease",
                        }}
                      >
                        <div style={{ position: "relative" }}>
                          {webinarData.webinarStatus === "upcoming" ? (
                            <div
                              className={
                                getDayFromDate(webinarData.webinarDate) ===
                                "SATURDAY"
                                  ? "ribbon fs-4 bg-green-lt"
                                  : "ribbon fs-4 bg-blue-lt"
                              }
                            >
                              {getDayFromDate(webinarData.webinarDate) ===
                              "SATURDAY"
                                ? "HINDI"
                                : "ENGLISH"}
                            </div>
                          ) : (
                            <div className="ribbon fs-4 bg-red">Expired</div>
                          )}
                          {getDayFromDate(webinarData.webinarDate) ===
                            "FRIDAY" && (
                            <LazyImageComponent
                              src={fridayWebinar}
                              alt={webinarData.webinarName}
                              className="card-img-top"
                              style={{
                                // height: "250px",
                                objectFit: "cover",
                              }}
                            />
                          )}
                          {getDayFromDate(webinarData.webinarDate) ===
                            "SATURDAY" && (
                            <LazyImageComponent
                              src={saturdayWebinar}
                              alt={webinarData.webinarName}
                              className="card-img-top"
                              style={{
                                // height: "250px",
                                objectFit: "cover",
                              }}
                            />
                          )}
                          {getDayFromDate(webinarData.webinarDate) ===
                            "SUNDAY" && (
                            <LazyImageComponent
                              src={sundayWebinar}
                              alt={webinarData.webinarName}
                              className="card-img-top"
                              style={{
                                // height: "250px",
                                objectFit: "cover",
                              }}
                            />
                          )}
                        </div>

                        {/* <div className="card-body d-flex flex-column">
                          <h3 className="card-title text-black fw-bold m-0 p-0">
                            {webinarData.webinarName}
                          </h3>

                          <div className="card-text text-muted m-0 p-0">
                            {expandedIndex
                              ? webinarData.description
                              : webinarData.description.slice(0, 100) +
                                (webinarData.description.length > 100
                                  ? "..."
                                  : "")}

                            {webinarData.description.length > 100 && (
                              <span
                                className="text-secondary"
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "5px",
                                  fontWeight: 500,
                                }}
                                onClick={() => toggleDescription()}
                              >
                                {expandedIndex ? " Show less" : " More"}
                              </span>
                            )}
                          </div>
                        </div> */}

                        <div className="card-footer text-center">
                          <h2>
                            🗓️ {webinarData.webinarDate} |{" "}
                            {webinarData.webinarDate
                              ? getDayFromDate(webinarData.webinarDate)
                              : ""}{" "}
                            <br />
                            🕒 {webinarData.webinarStartTime} -{" "}
                            {webinarData.webinarEndTime}
                          </h2>
                          <div>
                            {
                              <WebinarCountdown
                                key={new Date()}
                                webinarDate={webinarData.webinarDate}
                                webinarStartTime={webinarData.webinarStartTime}
                              />
                            }
                          </div>
                        </div>
                      </div>
                    ) : (
                      <p className="text-muted">No data available</p>
                    )}
                  </div>
                  <div className="text-start mt-2 ms-2">
                    <h3>Note:</h3>
                    <ul className="ms-2">
                      <li>
                        Please enter a valid email – the webinar link will be
                        sent there.
                      </li>
                      <li>
                        Use your WhatsApp number – we’ll also share the link on
                        WhatsApp.
                      </li>
                      <li>
                        The webinar starts on time – join using the link we send
                        you.
                      </li>
                      <li>
                        Do not share your webinar link – it can only be used on
                        one device.
                      </li>
                      <li>All time slots are in Indian Standard Time (IST).</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6 my-3 d-flex justify-content-center align-items-center">
                  <div className="card w-100">
                    <Formik
                      initialValues={webinarOrderInfo}
                      validationSchema={webinarOrderSchema}
                      onSubmit={handelNext}
                    >
                      {(props) => (
                        <Form>
                          {personalInfo === 1 && (
                            <div>
                              <div className="card-header">
                                <h2 className="page-title">
                                  Fill Details To Book Your Spot:
                                </h2>
                              </div>
                              <div className="card-body">
                                <div className="row ">
                                  <div className="col-12 col-lg-12 col-md-12">
                                    <div className="mb-3 row">
                                      <label className="w-25 form-label required  col-3">
                                        Name
                                      </label>
                                      <div className="w-100 col">
                                        <CustomInput
                                          name="personName"
                                          type="text"
                                        />
                                        {props.touched.personName &&
                                          props.errors.personName && (
                                            <p className="text-danger">
                                              {props.errors.personName}
                                            </p>
                                          )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="w-25 form-label required col-3">
                                        Email
                                      </label>
                                      <div className="w-100 col">
                                        <CustomInput name="email" type="text" />
                                        {props.touched.email &&
                                          props.errors.email && (
                                            <p className="text-danger">
                                              {props.errors.email}
                                            </p>
                                          )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="w-25 form-label required col-3">
                                        Mobile
                                      </label>
                                      <div className="w-100 col">
                                        <CustomInput
                                          name="contact"
                                          type="text"
                                        />
                                        {props.touched.contact &&
                                          props.errors.contact && (
                                            <p className="text-danger">
                                              {props.errors.contact}
                                            </p>
                                          )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="w-25 form-label required  col-3">
                                        Gender
                                      </label>
                                      <div className="w-100 col">
                                        <div className="d-grid d-lg-flex  gap-3">
                                          <div className="d-flex gap-2">
                                            <CustomRadioButton
                                              type="radio"
                                              name="gender"
                                              value="male"
                                            />
                                            <label>Male</label>
                                          </div>
                                          <div className="d-flex gap-2">
                                            <CustomRadioButton
                                              type="radio"
                                              name="gender"
                                              value="female"
                                            />
                                            <label>Female</label>
                                          </div>
                                          <div className="d-flex gap-2">
                                            <CustomRadioButton
                                              type="radio"
                                              name="gender"
                                              value="other"
                                            />
                                            <label>Other</label>{" "}
                                          </div>
                                          <div className="d-flex gap-2">
                                            <CustomRadioButton
                                              type="radio"
                                              name="gender"
                                              value="prefer_not_to_say"
                                            />
                                            <label>Prefer not to say</label>
                                          </div>
                                        </div>
                                        {props.touched.gender &&
                                          props.errors.gender && (
                                            <p className="text-danger">
                                              {props.errors.gender}
                                            </p>
                                          )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="w-25 form-label required  col-3">
                                        Age
                                      </label>
                                      <div className="w-100 col">
                                        <CustomInput name="age" type="text" />
                                        {props.touched.age &&
                                          props.errors.age && (
                                            <p className="text-danger">
                                              {props.errors.age}
                                            </p>
                                          )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="w-25 form-label required  col-3">
                                        City
                                      </label>
                                      <div className="w-100 col">
                                        <CustomInput name="city" type="text" />
                                        {props.touched.city &&
                                          props.errors.city && (
                                            <p className="text-danger">
                                              {props.errors.city}
                                            </p>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="card-footer">
                                <ul>
                                  <li>
                                    Please double-check your email and WhatsApp
                                    number, as the link will be shared on both
                                    WhatsApp and email.
                                  </li>

                                  <li>
                                    On successful payment, you will receive
                                    confirmation within one hour on your email
                                    and WhatsApp.
                                  </li>
                                  <li>
                                    Make sure your email inbox is not full and
                                    that you're checking the correct folders
                                    (including spam/junk if needed).
                                  </li>
                                  <li>
                                    If you face any issues, please contact us on
                                    +91 9870424425 or via email at
                                    [contact@kryzen.com] for faster assistance.
                                    We're here to help!
                                  </li>
                                </ul>
                                <input
                                  type="checkbox"
                                  checked={isChecked}
                                  onChange={(e) =>
                                    setIsChecked(e.target.checked)
                                  }
                                />{" "}
                                I have read and agree to the above instructions.
                                <div className="btn-list justify-content-end">
                                  <FormSubmitButton
                                    disabled={!token}
                                    buttonText="Next"
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                          {personalInfo === 2 && (
                            <div>
                              <div
                                className="card p-4  m-auto mt-3 mb-3"
                                style={{
                                  width: "350px",
                                  borderRadius: "10px",
                                  boxShadow:
                                    "rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px",
                                }}
                              >
                                <h3 className=" mb-3 text-center">
                                  Confirm your payment
                                </h3>
                                <div className="bg-light p-3 rounded mb-3">
                                  <h4 className="mb-3">Details</h4>
                                  <div className="d-flex justify-content-between mb-2">
                                    <span>Name</span>
                                    <span>{props.values.personName}</span>
                                  </div>
                                  <div className="d-flex justify-content-between mb-2">
                                    <span>Email</span>
                                    <span>{props.values.email}</span>
                                  </div>
                                  <div className="d-flex justify-content-between mb-2">
                                    <span>Contact</span>
                                    <span>{props.values.contact}</span>
                                  </div>
                                  <div className="d-flex justify-content-between mb-2">
                                    <span>Date</span>
                                    <span>
                                      {DateTime.now()
                                        .setZone("Asia/Kolkata")
                                        .toISODate()}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between mb-2">
                                    <span>Amount</span>
                                    <span>
                                      ₹
                                      {discountedPrice
                                        ? discountedPrice
                                        : props.values.amount}
                                    </span>
                                  </div>
                                  <hr />
                                  <div className="d-flex justify-content-between">
                                    <span>Total amount</span>
                                    <span>
                                      ₹
                                      {discountedPrice
                                        ? discountedPrice
                                        : props.values.amount}
                                    </span>
                                  </div>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <button
                                    className="btn btn-outline-secondary"
                                    onClick={() =>
                                      setpersonalInfo(personalInfo - 1)
                                    }
                                  >
                                    Cancel Payment
                                  </button>
                                  <button
                                    className="btn btn-primary"
                                    onClick={() => handelSubmit(props.values)}
                                  >
                                    Confirm Payment
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default WebinarNewForm;
